import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";

import type { UseFormRegisterReturn } from "react-hook-form";

interface EmailBisonCustomUrlFieldProps {
  registration: UseFormRegisterReturn;
  error?: string;
}

export default function EmailBisonCustomUrlField({
  registration,
  error,
}: EmailBisonCustomUrlFieldProps) {
  return (
    <FormField
      label="Custom domain"
      htmlFor="emailbison-custom-url"
      hint="Only required if you access EmailBison on your own domain. Leave empty to use the default one"
      error={error}
    >
      <Input
        id="emailbison-custom-url"
        placeholder="https://mail.yourdomain.com"
        {...registration}
      />
    </FormField>
  );
}
